

export default defineNuxtRouteMiddleware(async (to) => {

  if (import.meta.env.SSR) return;

  const authStore = useAuthStore();

  // If not authenticated and not on root, redirect to root
  if (!authStore.isAuthenticated) {
    if (to.path === "/") return; // If already on root, do nothing
    showInfoNotification("You need to be logged in to visit this page.", 10000);
    return navigateTo("/");
  }

  await authStore.loadUser();

  // If not connected to Discord, redirect to /customs
  if (authStore.discordLinkRequired) {
    if (to.path === "/customs") return; // If already on /customs, do nothing
    return navigateTo("/customs");
  }

  // If on /customs and user is connected, redirect to root
  if (to.path === "/customs") return navigateTo("/mints");
  if (to.path === "/") return navigateTo("/mints");
});
